import { create, text, visitable } from 'ember-cli-page-object';
import flashMessage from 'core/test-support/pages/components/flash-message';
import CreateProvidersComponent from 'vagrant/test-support/pages/components/create/providers';
import CreateUploadComponent from 'vagrant/test-support/pages/components/create/upload';
export default create({
  visit: visitable('/private/registries/:registry/boxes/:box/versions/:version/add-architecture'),
  title: text('[data-test-title]'),
  subtitle: text('[data-test-subtitle]'),
  providersForm: CreateProvidersComponent(),
  upload: CreateUploadComponent(),
  flash: flashMessage
});